import { z } from 'zod'

const phoneRegex =
  /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/

export const individualInquirySchema = z.object({
  customerType: z.literal('individual'),
  spareBatteries: z.number().min(0),
  quantity: z.number().min(1),
  name: z.string().min(2, 'Ime mora imati najmanje 2 karaktera'),
  email: z.string().email('Neispravna email adresa'),
  phone: z.string().regex(phoneRegex, 'Neispravan broj telefona'),
  city: z.string().min(2, 'Grad je obavezan'),
  productId: z.string().min(1, 'Morate izabrati proizvod'),
  message: z.string().optional(),
})

export const businessInquirySchema = z.object({
  customerType: z.literal('business'),
  spareBatteries: z.number().min(0),
  quantity: z.number().min(1),
  companyName: z.string().min(2, 'Naziv kompanije je obavezan'),
  pibVat: z.string().min(5, 'PIB/VAT broj je obavezan'),
  maticniBroj: z.string().min(5, 'Matični broj je obavezan'),
  address: z.string().min(5, 'Adresa je obavezna'),
  city: z.string().min(2, 'Grad je obavezan'),
  contactPerson: z.string().min(2, 'Ime kontakt osobe je obavezno'),
  email: z.string().email('Neispravna email adresa'),
  phone: z.string().regex(phoneRegex, 'Neispravan broj telefona'),
  productId: z.string().min(1, 'Morate izabrati proizvod'),
  message: z.string().optional(),
})

export const inquiryFormSchema = z.discriminatedUnion('customerType', [
  individualInquirySchema,
  businessInquirySchema,
])

export const demoRequestSchema = z.object({
  name: z.string().min(2, 'Ime mora imati najmanje 2 karaktera'),
  email: z.string().email('Neispravna email adresa'),
  phone: z.string().regex(phoneRegex, 'Neispravan broj telefona'),
  city: z.string().min(2, 'Grad je obavezan'),
  fullAddress: z.string().min(10, 'Puna adresa je obavezna'),
  preferredDate: z.string().refine((date) => {
    const selectedDate = new Date(date)
    const minDate = new Date()
    minDate.setDate(minDate.getDate() + 5)
    return selectedDate >= minDate
  }, 'Demonstracija mora biti zakazana najmanje 5 dana unapred'),
  timeWindow: z.string().min(1, 'Vremenski period je obavezan'),
  loadType: z.string().optional(),
  estimatedWeight: z.string().optional(),
  notes: z.string().optional(),
})

export const contactFormSchema = z.object({
  name: z.string().min(2, 'Ime mora imati najmanje 2 karaktera'),
  email: z.string().email('Neispravna email adresa'),
  phone: z.string().regex(phoneRegex, 'Neispravan broj telefona'),
  message: z.string().min(10, 'Poruka mora imati najmanje 10 karaktera'),
})

export type InquiryFormData = z.infer<typeof inquiryFormSchema>
export type DemoRequestFormData = z.infer<typeof demoRequestSchema>
export type ContactFormData = z.infer<typeof contactFormSchema>
